<div class="breadcrumb" fxFlex='100' fxLayout='row'>
    <div *ngFor="let items of bread; let i = index" >        
        <span *ngIf='i > 0' style="margin: 0 5px;">/</span>

        <a *ngIf='!items.active' style="cursor: pointer;" (click)="goToUrl(items.url, items.params)">{{ items.title }}</a>
        <span *ngIf='items.active' class="active">{{ items.title }}</span>
    </div>
</div>